

exports.__esModule = true;

var _index = require('squid/index');

var _index2 = require('xo-device-info/dist/index');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-form-components/src/place-of-birth/directive');

require('components/xo-form-components/src/gender-type/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoSignupOptions', {
    tag: 'xo-signup-options',
    template: _template2['default'],

    props: {
        flags: {
            type: 'var'
        },
        onboard: {
            type: 'var'
        },
        singlePagePaymentForm: {
            type: 'var'
        },
        validated: {
            type: 'var'
        },
        sepa: {
            type: 'var'
        },
        guestUpgrade: {
            type: 'var'
        }
    },

    resolve: {
        experiments: function experiments() {
            return {
                singlePassword: (0, _index.$pxp)('xoon_single_password', { 'ctx.COUNTRY': _index.$locale.country }, 'xoon_single_password_test')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
            this.flags.nationalIdFlag = _index.$config.nationalIdRequiredCountries && _index.$config.nationalIdRequiredCountries.indexOf(_index.$locale.country) > -1;
            this.isGenderFieldEnabled = (0, _index.$feature)('gender', false, this.locale.country);
            // Market Opt-in checked if country is canada 
            this.marketingOptInChecked = (0, _index.$feature)('checkMarketingOptIn', false, this.locale.country);
        },
        populate: function populate() {
            if (_index.$locale.country === 'US') {
                this.onboard.eConsentTermsContent = 'signupTerms.signupTCPA3';
            } else {
                this.onboard.eConsentTermsContent = this.onboard.fiMode === 'bank' ? 'signupTerms.signupBank' : 'signupTerms.signupC';
            }

            var singlePasswordPXP = this.experiments.singlePassword;
            if (singlePasswordPXP) {
                if (singlePasswordPXP.treatment_name || _index2.$DeviceInfo.isDevice()) {
                    this.flags.singlePassword = true;
                }
            }
        }
    },

    actions: {
        openSepa: function openSepa() {
            this.sepa.show = true;
        }
    }
});


_index.$Component;

_index.$locale;

_index.$pxp;

_index.$config;

_index.$feature;

_index2.$DeviceInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/onboardOptions/signup/directive.js
// module id = ./components/xo-guest-components/src/guest/onboardOptions/signup/directive.js
// module chunks = 1